/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle': {
    width: 16,
    height: 16,
    viewBox: '0 0 8 8',
    data: '<g id="首页"><g id="saas-首页无项目" transform="translate(-16 -312)"><path pid="0" id="img-circle" class="st0" d="M20 318c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/circle.js